import React from 'react'
import { withRouter } from 'react-router-dom'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { Checkbox } from 'loankeeper-common/common'
import LKGrid from '../../../../shared/LKGrid'
import LKButton from '../../../../shared/LKButton'
import { connect } from 'react-redux'
import createAction from 'loankeeper-common/helpers/createAction'
import { deleteNote } from '../../../../../store/loan'
import LKModal, { actions as LKModalActions } from '../../../../shared/LKModal'
import { actions as DCActions } from '../../../../DetailsContainer'
import translate, { translateLKMessage, translateWebMessages } from '../../../translator'
import { actions } from './constants'
import { MODAL_NAME as REMINDER_MODAL } from './Modal/ReminderModal'
import { getFilter, getFilteredData } from './selectors'
import { withConstantPermissions, withUserConfig } from '../../../../shared'
import { openFileDetails } from '../../../../FileDetails'
import { config } from './configs'

const REMINDER_DELETE_MODAL = 'ReminderDeleteModal'

@withRouter
@withUserConfig('ID as UserID')
// @ts-ignore
@withConstantPermissions()
// @ts-ignore
@connect(
  // @ts-ignore
  (state, { ID }) => ({
    filter: getFilter(state, ID),
  }),

  // @ts-ignore
  (dispatch, { ID, hash }) => ({
    openFileDetails: (ID, hash, type) => dispatch(openFileDetails({ ID, hash, type })),
    // @ts-ignore
    openReminderModal: (data) => dispatch(LKModalActions.open({ name: REMINDER_MODAL, data })),
    openReminderDelete: (modalProps) =>
      dispatch(
        LKModalActions.openConfirmation(REMINDER_DELETE_MODAL, {
          message: translateLKMessage('CONFIRM_REMINDER_DELETE'),
          ...modalProps,
        }),
      ),
    openErrorModal: (messsage) => dispatch(LKModalActions.openError(messsage)),
    fetchPage: () =>
      dispatch(
        DCActions.fetchPage({
          type: 'Loan',
          ID,
          hash,
          page: 'reminders',
        }),
      ),

    initialize: (filter) => {
      dispatch(createAction(actions.INITIALIZE, { filter }, { ID }))
    },

    changeFilter: (filter) => {
      dispatch(createAction(actions.CHANGE_FILTER, { filter }, { ID }))
    },

    // @ts-ignore
    deleteNote: (params) => dispatch(deleteNote(params)),
  }),
)
class Reminders extends React.PureComponent<any> {
  componentDidMount() {
    const filter = this.props.filter !== undefined ? this.props.filter : 0
    this.props.initialize(filter)
  }

  viewFile = (ID, hash, Ext) => {
    this.props.openFileDetails(ID, hash, Ext)
  }

  getContextMenuItems = ({ node: { data } }) => [
    {
      name: translateWebMessages('cmd_preview_linkedfile'),
      action: () => this.openReminderPreview(data),
      icon: 'preview',
    },
    ...(this.props.UserID === data.UserID || this.props.permissions.EDIT_RMD_ALIEN
      ? [
          {
            name: translate('cmd_edit'),
            icon: 'edit',
            action: () => this.openReminderEdit(data),
            permissionKey: 'EDIT_RMD',
          },
        ]
      : []),

    ...(this.props.UserID === data.UserID || this.props.permissions.DEL_RMD_ALIEN
      ? [
          {
            name: translate('cmd_delete'),
            icon: 'delete',
            action: () => this.props.openReminderDelete(data),
            permissionKey: 'DEL_RMD',
          },
        ]
      : []),
    ...(data.LFLID !== null &&
    this.props.linkedfiles.find((lf) => lf.ID === data.LFLID) !== undefined &&
    ['jpg', 'pdf'].includes(this.props.linkedfiles.find((lf) => lf.ID === data.LFLID).Ext.toLowerCase())
      ? [
          {
            name: translate('cmd_view_lfl'),
            icon: 'preview',
            action: () => {
              const { LFLID } = data

              if (LFLID) {
                const { HashSum_FileID_: hash, Ext } = this.props.linkedfiles.find((lf) => lf.ID === LFLID)

                this.viewFile(LFLID, hash, Ext)
              }
            },
          },
        ]
      : []),
  ]

  openReminderPreview = (data) => this.openReminder({ ...data, __readonly: true })

  openReminderAdd = () => this.props.openReminderModal()

  openReminderEdit = (data) => this.openReminder(data)

  openReminder = (data) => {
    this.props.openReminderModal({
      ...data,
      Comment: data.Body,
      GDate: new LKDate(data.GDate).toString(),
      StateID: data.StateID === 1,
    })
  }

  deleteReminder = async (data) => {
    try {
      await this.props.deleteNote({
        LoanID: this.props.ID,
        HashSum_LoanID_: this.props.hash,
        ID: data.ID,
      })
      this.props.fetchPage()
    } catch (e) {
      this.props.openErrorModal(e.Error.Message || e.Error.Text)
    }
  }

  closeFile = () => {
    this.setState({ open: false })
  }

  render() {
    const { instanceName, changeFilter, filter, data } = this.props
    const filtered = getFilteredData(data, filter)

    return (
      <div className="u-flex u-fluid u-directionColumn">
        <div className="u-fluid u-relative">
          <LKGrid
            instanceName={instanceName}
            rowData={filtered}
            getContextMenuItems={this.getContextMenuItems}
            {...config}
          />
        </div>

        <div className="u-padding-5 u-flex u-alignCenter">
          {/* @ts-ignore */}
          <LKButton alias="add" onClick={this.openReminderAdd} permission="ADD_RMD">
            {translate('cmd_add_tag')}
          </LKButton>

          {/* @ts-ignore */}
          <LKModal.Confirmation name={REMINDER_DELETE_MODAL} onConfirm={this.deleteReminder} />

          <Checkbox
            label={translate('chk_active_reminders')}
            className="u-marginLeft-10"
            checked={Boolean(filter) ? filter : 0}
            onChange={changeFilter}
            indeterminable
          />
        </div>
      </div>
    )
  }
}

export default Reminders
